// 链接
export default process.env.NODE_ENV === "development"
  ? "http://wifi.iot098.cn/"
  : "";
